import 'whatwg-fetch';
import { DeveloperProfile } from './components/profile';

import './styles/global.css';

export default DeveloperProfile;
